//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import ScheduleTable from "@/pages/Warehouses/components/ScheduleTable.vue";
import StoresTable from "@/pages/Warehouses/components/StoresTable.vue";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

const TABLE_LIST_COLUMNS = [
  {
    name: "code",
    required: false,
    label: "Código",
    align: "right",
    field: row => row.code,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "name",
    required: false,
    align: "left",
    label: "Nome Armazém",
    field: row => row.name,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "type",
    required: false,
    align: "left",
    label: "Tipo Operador",
    field: row => row.storage_type.name,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "retailer",
    required: false,
    align: "left",
    label: "Entidade Gestora",
    field: row => (row.retailer ? row.retailer.name : 'N/A'),
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "nipc",
    required: false,
    align: "left",
    label: "NIPC",
    field: row => row.nipc,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "phone",
    required: false,
    align: "left",
    label: "Telefone",
    field: row => row.phone,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "email",
    required: false,
    align: "left",
    label: "E-mail",
    field: row => row.email,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "manager",
    required: false,
    align: "left",
    label: "Responsável",
    field: row => row.management,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "facility-schedules",
    label: "Horário",
    align: "left",
    field: row => row.facility_schedules,
    format: DEFAULT_FORMAT,
    sortable: false,
    icon: {
      conditional: false,
      content: {
        name: 'schedule',
        color: 'blue-10',
        customComponent: ScheduleTable,
        customComponentProps: {
          data: "value"
        }
      }
    }
  },
  {
    name: "opening-date",
    required: false,
    align: "left",
    label: "Data Abertura",
    field: row => row.activity_start,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "closing-date",
    required: false,
    align: "left",
    label: "Data Fecho",
    field: row => row.activity_end,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "stores",
    required: false,
    align: "left",
    label: "Lojas",
    field: row => row.stores,
    sortable: false,
    icon: {
      conditional: false,
      content: {
        name: 'shopping_cart',
        color: 'blue-10',
        customComponent: StoresTable,
        customComponentProps: {
          data: "value"
        }
      }
    }
  }
];

export default {
  name: "TraitsTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table
  },
  data: function() {
    return {
      columns: TABLE_LIST_COLUMNS,
      separator: "horizontal",
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  methods: {
    renderRightSide: function(event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function(event) {
      this.$emit("filter-changed", event);
    }
  },
  computed: {
    visibleColumns: function() {
      return this.columns.map(column => column.name);
    },
    sortStatus: function() {
      return Array(this.columns.length).fill(true);
    },
    filterData: function() {
      return Object.assign(
        {},
        Array(this.columns.length)
          .fill({})
          .map((item, index) => ({
            index: index,
            colKey: this.columns[index].name,
            exclude: [""]
          }))
      );
    }
  }
};
